import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  FormHelperText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const RecordedContactEndpointStep = ({
  ephemeralRows,
  formErrors,
  handleEphemeralRowChange,
  handleAddEndpoint,
  handleRemoveEndpoint,
  channelOptions,
}) => {
  return (
    <Box mt={2}>
      {formErrors.endpoints && (
        <FormHelperText error>{formErrors.endpoints}</FormHelperText>
      )}
      {ephemeralRows.map((row, index) => (
        <Box
          key={row.id}
          display="flex"
          alignItems="flex-end"
          gap={2}
          sx={{ mb: 2 }}
        >
          <FormControl sx={{ minWidth: 180 }}>
            <FormLabel>Channel</FormLabel>
            <Select
              value={row.channel}
              onChange={(e) =>
                handleEphemeralRowChange(index, "channel", e.target.value)
              }
              displayEmpty
              disabled={row.added}
            >
              <MenuItem value="">
                <em>Select Channel</em>
              </MenuItem>
              {channelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ flex: 2, minWidth: 220 }}>
            <FormLabel>Identifier</FormLabel>
            <TextField
              placeholder="Enter Identifier"
              value={row.identifier}
              onChange={(e) =>
                handleEphemeralRowChange(index, "identifier", e.target.value)
              }
              disabled={row.added}
            />
          </FormControl>
          <IconButton
            color={
              row.added
                ? "success"
                : !row.added && row.channel && row.identifier
                ? "primary"
                : "default"
            }
            sx={{
              ...(!row.added && row.channel && row.identifier
                ? { boxShadow: 3, border: '2px solid #1976d2' }
                : {}),
              alignSelf: 'flex-start',
              mt: '26px',
            }}
            onClick={() => {
              if (!row.added) handleAddEndpoint(index);
            }}
          >
            {row.added ? <CheckIcon sx={{ color: "green" }} /> : <AddIcon />}
          </IconButton>
          {row.added && (
            <IconButton
              color="error"
              onClick={() => handleRemoveEndpoint(index)}
              sx={{
                alignSelf: 'flex-start',
                mt: '26px',
              }}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default RecordedContactEndpointStep;
